import { useMutation, UseMutationResult } from '@tanstack/react-query';

import multiChannelApi from '../../../lib/api/multiChannel/multiChannelApi';
import {
  MultiChannelOrderItemBulkInsertRequestDto,
  MultiChannelOrderItemBulkInsertResponseDto,
} from '../../../types/api/multi-channels';

export const useCreateOrderItems = (): UseMutationResult<
  MultiChannelOrderItemBulkInsertResponseDto,
  unknown,
  MultiChannelOrderItemBulkInsertRequestDto,
  unknown
> => {
  return useMutation((payload: MultiChannelOrderItemBulkInsertRequestDto) => multiChannelApi.createOrderItems(payload));
};
